/* eslint-disable @nx/enforce-module-boundaries -- deep `libs/xplat/api/dto` paths avoid the dto barrel -> tool-tracker -> xplat-api-services cycle */
import type { ForemanEmployeeInOut } from '../../../../dto/src/lib/models/foreman/foreman-employee-in-out.model';
import { newGuid } from '@ups/xplat/utils';
import { isPersistableForemanEmployeeInOut } from './foreman-employee-in-out-identity.utils';

export {
  getPersistableInOutsSignature,
  havePersistableInOutsChanged,
  isPersistableForemanEmployeeInOut,
  isValidForemanGuid,
} from './foreman-employee-in-out-identity.utils';

/** Clone time segments for a newly created labor (e.g. copy previous day). */
export function cloneInOutsForNewLabor(
  inOuts: ForemanEmployeeInOut[] | null | undefined,
  laborId: string,
  employeeJobId: string
): ForemanEmployeeInOut[] {
  return (inOuts ?? [])
    .filter(isPersistableForemanEmployeeInOut)
    .map((entry) => ({
      ...entry,
      foremanEmployeeInOutID: newGuid(),
      foremanEmployeeLaborID: laborId,
      foremanEmployeeJobID: employeeJobId,
      bActive: entry.bActive ?? true,
    }));
}

/**
 * Attach time segments to a labor for sync/submit. Preserves in-out ids when
 * already linked to the target labor; assigns new ids when re-parented.
 */
export function linkInOutsToLabor(
  inOuts: ForemanEmployeeInOut[] | null | undefined,
  laborId: string,
  employeeJobId: string
): ForemanEmployeeInOut[] {
  return (inOuts ?? [])
    .filter(isPersistableForemanEmployeeInOut)
    .map((entry) => ({
      ...entry,
      foremanEmployeeInOutID:
        entry.foremanEmployeeLaborID === laborId
          ? entry.foremanEmployeeInOutID
          : newGuid(),
      foremanEmployeeLaborID: laborId,
      foremanEmployeeJobID: entry.foremanEmployeeJobID || employeeJobId,
    }));
}
